
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[smartBanner]/city/[slug]",
      function () {
        return require("private-next-pages/[smartBanner]/city/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[smartBanner]/city/[slug]"])
      });
    }
  